var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_25772",
    "data-name": "Group 25772",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.054,
    height: 29,
    viewBox: "0 0 33.054 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6159",
    "data-name": "Rectangle 6159",
    width: 33.054,
    height: 29,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25161",
    "data-name": "Group 25161",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13036",
    "data-name": "Path 13036",
    d: "M15.726,18.977a.8.8,0,0,0,1.6,0l.549-9.048a.8.8,0,0,0-.8-.851h-1.1a.8.8,0,0,0-.8.851Zm17,6.422L18.594,1.187a2.394,2.394,0,0,0-4.136,0L.33,25.4A2.394,2.394,0,0,0,2.4,29H30.655a2.394,2.394,0,0,0,2.068-3.6m-1.492,1.537a.652.652,0,0,1-.576.333H2.4a.664.664,0,0,1-.574-1L15.953,2.059a.664.664,0,0,1,1.147,0L31.229,26.271a.652.652,0,0,1,0,.665m-14.7-6.267a1.964,1.964,0,1,0,1.963,1.964,1.965,1.965,0,0,0-1.963-1.964",
    transform: "translate(0.001 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9a82e77719f35a077c92d83bb59433a7.svg";
export { ForwardRef as ReactComponent };